const SITELINKS = {
  profiles: '/profile',
  users: {
    list: '/users',
    add: '/users/add',
    edit: '/users/:id',
  },
  stores: {
    list: '/stores',
    add: '/stores/add',
    edit: '/stores/:storeId',
  },
  packages: {
    bySearchCode: '/packagesBySearchCode',
    list: '/packages',
    history: '/packages/history',
    withoutZone: '/packages/withoutZone',
    massive: '/massive/add',
    edit: '/packages/:externalCode',
    editById: '/packages/id/:id',
    send: '/packages/send',
    view: '/packages/view/:id',
  },
  storePackages: {
    list: '/store/packages',
    history: '/store/packages/history',
    massive: '/store/massive/add',
    massiveLegacy: '/store/massive/legacy',
  },
  support: {
    index: '/support',
  },
  error: '/error',
};

export default SITELINKS;
